import React, { useState } from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext';
import AuthModal from '../Modals/AuthModal';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../../common/SafeIcon';

const { FiShield, FiAlertTriangle } = FiIcons;

const ProtectedRoute = ({ children, requiredRole }) => {
  const { user, loading, roleLoading, roleError } = useAuth();
  const location = useLocation();
  const [showAuthModal, setShowAuthModal] = useState(true);

  // Show full-screen loader during initial auth + role loading
  if (loading || roleLoading) {
    return (
      <div className="min-h-screen bg-brand-light flex items-center justify-center">
        <div className="flex flex-col items-center gap-4">
          <div className="w-12 h-12 border-4 border-accent-gold/20 border-t-accent-gold rounded-full animate-spin" />
          <p className="text-text-muted text-sm font-bold uppercase tracking-widest">
            {roleLoading ? 'Resolving permissions...' : 'Loading...'}
          </p>
        </div>
      </div>
    );
  }

  // Show error state if role resolution failed but user is authenticated
  if (roleError && user) {
    return (
      <div className="min-h-screen bg-brand-light flex flex-col items-center justify-center p-6 text-center">
        <div className="w-20 h-20 bg-amber-500/10 rounded-full flex items-center justify-center mb-6">
          <SafeIcon icon={FiAlertTriangle} className="w-10 h-10 text-amber-500" />
        </div>
        <h2 className="text-2xl font-serif text-accent-navy mb-3">Permission Resolution Failed</h2>
        <p className="text-text-muted max-w-md mb-4">
          {roleError}
        </p>
        <p className="text-text-muted max-w-md mb-8 text-sm">
          We could not determine your access level. Some features may be restricted. Please try signing in again.
        </p>
        <button
          onClick={() => {
            setShowAuthModal(true);
            window.location.hash = '/';
          }}
          className="px-8 py-3 bg-accent-navy text-white rounded-xl font-bold hover:bg-accent-navy/90 transition-colors"
        >
          Return Home
        </button>
      </div>
    );
  }

  if (!user) {
    return <Navigate to="/login" replace state={{ from: location }} />;
  }

  if (requiredRole && !['admin', 'superadmin'].includes(user.role)) {
    return <Navigate to="/user/dashboard" replace />;
  }

  return children;
};

export default ProtectedRoute;